// setDevice.js

export function setDevice() {

  // Check for mobile devices
  const isMobileDevice = () => {
    if( navigator.userAgent.match(/Android/i) ||
     navigator.userAgent.match(/webOS/i) ||
     navigator.userAgent.match(/iPhone/i) ||
     navigator.userAgent.match(/iPad/i) ||
     navigator.userAgent.match(/iPod/i)
    ) {
      window.mobileDevice = true
      document.body.classList.add('is-mobile')
    } else {
      window.mobileDevice = false
    } 

    if (window.innerWidth < 768) {
      document.body.classList.add('is-mobile')
    } else {
      document.body.classList.remove('is-mobile')
    }
  }
  const isBrowser = () => {

    var navUserAgent = navigator.userAgent
    var browserName  = navigator.appName
    var browserVersion  = ''+parseFloat(navigator.appVersion) 
    var majorVersion = parseInt(navigator.appVersion,10)
    var tempNameOffset,tempVersionOffset,tempVersion


    if ((tempVersionOffset=navUserAgent.indexOf("Opera"))!=-1) {
     browserName = "opera"
     browserVersion = navUserAgent.substring(tempVersionOffset+6)
     if ((tempVersionOffset=navUserAgent.indexOf("Version"))!=-1) 
       browserVersion = navUserAgent.substring(tempVersionOffset+8)
    } else if ((tempVersionOffset=navUserAgent.indexOf("MSIE"))!=-1) {
     browserName = "ie"
     browserVersion = navUserAgent.substring(tempVersionOffset+5)
    } else if ((tempVersionOffset=navUserAgent.indexOf("Chrome"))!=-1) {
     browserName = "chrome"
     browserVersion = navUserAgent.substring(tempVersionOffset+7)
    } else if ((tempVersionOffset=navUserAgent.indexOf("Safari"))!=-1) {
     browserName = "safari"
     browserVersion = navUserAgent.substring(tempVersionOffset+7)
     if ((tempVersionOffset=navUserAgent.indexOf("Version"))!=-1) 
       browserVersion = navUserAgent.substring(tempVersionOffset+8)
    } else if ((tempVersionOffset=navUserAgent.indexOf("Firefox"))!=-1) {
     browserName = "firefox"
     browserVersion = navUserAgent.substring(tempVersionOffset+8)
    } else if ( (tempNameOffset=navUserAgent.lastIndexOf(' ')+1) < (tempVersionOffset=navUserAgent.lastIndexOf('/')) ) {
     browserName = navUserAgent.substring(tempNameOffset,tempVersionOffset)
     browserVersion = navUserAgent.substring(tempVersionOffset+1)
     if (browserName.toLowerCase()==browserName.toUpperCase()) {
      browserName = navigator.appName
     }
    }

    // trim version
    if ((tempVersion=browserVersion.indexOf(""))!=-1)
       browserVersion=browserVersion.substring(0,tempVersion)
    if ((tempVersion=browserVersion.indexOf(" "))!=-1)
       browserVersion=browserVersion.substring(0,tempVersion)

    document.body.classList.add(browserName)

  }
  isMobileDevice()
  isBrowser()
  
  window.addEventListener("resize", isMobileDevice, true)
  // Check if iOS device
  if( navigator.userAgent.match(/iPhone/i) ||
   navigator.userAgent.match(/iPad/i) ||
   navigator.userAgent.match(/iPod/i) ) { 
    document.body.classList.add('iosdevice')
  }

  // this method is used to prevent the hover default action on main menu
  var isTouch =  !!("ontouchstart" in window) || window.navigator.msMaxTouchPoints > 0
  if( !isTouch ){ }

  // hide for the iPhone´s search bar to minimize fixed back with scroll issue
  // /mobi/i.test(navigator.userAgent) && !location.hash && setTimeout(function () {
  //   if (!pageYOffset) window.scrollTo(0, 1)
  // }, 999)

  // fix for bfcache Safari Browser
  var is_safari = navigator.userAgent.indexOf("Safari") > -1
  if ((is_safari) && (navigator.userAgent.indexOf('Mac')>1) || (/iphone|ipod|ipad.*os 5/gi).test(navigator.appVersion)) {
    window.onpageshow = function(evt) {
      if (evt.persisted) {
        location.reload()
      }
    }
  }

}

